import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-navbar-loggin',
  imports: [RouterLink],
  templateUrl: './navbar-loggin.component.html',
  styleUrl: './navbar-loggin.component.css'
})
export class NavbarLogginComponent {
  mobileMenuOpen = false;
  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }
}
